/*
Soporte para el "Search" con palabras
Autor: Benjamín León
Fecha: 2025-01-20
*/

import removeAccents from './removeAccents'

const filterContains = <T>({
  list,
  filterField,
  searchTerm,
  dateSince,
  dateUntil,
}: {
  list: T[]
  filterField: (item: T) => string | Date
  searchTerm?: string
  dateSince?: string
  dateUntil?: string
}) => {
  let out = [...list]

  if (searchTerm) {
    const lowerSearch = removeAccents(searchTerm).toLowerCase()

    out = list.filter((item) => removeAccents(String(filterField(item) ?? '').toLowerCase()).includes(lowerSearch))
  }

  if (dateSince) {
    out = out.filter((item) => {
      const date = new Date(filterField(item))

      return date >= new Date(dateSince)
    })
  }

  if (dateUntil) {
    out = out.filter((item) => {
      const date = new Date(filterField(item))

      return date <= new Date(dateUntil)
    })
  }

  return out
}

export default filterContains
